import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/routes/Home'
import IdeaChallenges from '@/components/routes/IdeaChallenges'
import IdeaChallenge from '@/components/routes/IdeaChallenge'
import Login from '@/components/routes/Login'
import MakeYourMarkChallenge from '@/components/routes/MakeYourMarkChallenge'
import AllMakeYourMarks from '@/components/routes/AllMakeYourMarks'
import Communities from '@/components/routes/Communities'
import Community from '@/components/routes/Community'
import VEAward from '@/components/routes/VEAward'
import VEAwards from '@/components/routes/VEAwards'
import VEAwardForRewardManagerReports from '@/components/routes/VEAwardForNomination'
import MyProfile from '@/components/routes/MyProfile'
import UserProfile from '@/components/routes/UserProfile'
import VEAwardMax2Nomination from '@/components/routes/VEAwardRecognition'
import VEAwardsEmployee from '@/components/routes/VEAwardsEmployee'
import VEAwardsEmployeeYear from '@/components/routes/VEAwardsEmployeeYear'
import VEAwardsEmployeeRegional from '@/components/routes/VEAwardsEmployeeRegional'
import AllIdeas from '@/components/routes/AllIdeas'
import NominationReview from '@/components/routes/nominationSent'
import NominationBUReview from '@/components/routes/NominationBUSent'
import NominationBUReviewImage from '@/components/routes/NominationBUReviewImage'
import NominationMCGReview from '@/components/routes/NominationMCGReview'
import NominationSponsorReview from '@/components/routes/NominationSponsorReview'
import NominationDowngradeReview from '@/components/routes/nd'
import NominationReviewEmployeeAward from '@/components/routes/NominationReviewEmployeeAward'
import NominationManagerEmployeeAward from '@/components/routes/NominationManagerEmployeeAward'
import ReportVEAwards from '@/components/routes/ReportVEAwards'
import VEAwardForAllRewardReports from '@/components/routes/VEAwardForAllGroups'
import VEAwardForEmployeeNomination from '@/components/routes/VEAwardForEmployeeNomination'
import VEAwardForEmployeeNominationRegional from '@/components/routes/VEAwardForEmployeeNominationRegional'
import VEAwardForBUEmployeeNomination from '@/components/routes/VEAwardForBUEmployeeNomination'
import VEAwardReportForEmployeeYear from '@/components/routes/VEAwardForEmployeeYearNomination'
import VEAwardsMCGEmployeeYear from '@/components/routes/VEAwardsMCGEmployeeYear'
import VEAwardForMCGEmployeeYearReports from '@/components/routes/VEAwardForMCGEmployeeYearNomination'
import VEAwardForMCGEmployeeYearCountReports from '@/components/routes/VEAwardForMCGEmployeeYearNominationCount'
import Search from '@/components/routes/Search'
import Page from '@/components/routes/Page'
import SingleIdea from '@/components/routes/SingleIdea'
import SingleAbuseReport from '@/components/routes/SingleAbuseReport'
import ReportAbuseReports from '@/components/routes/ReportAbuseReports'
import DigitalStore from '@/components/routes/DigitalStore'
import Media from '@/components/routes/Media'
import ReportIdeaChallenges from '@/components/routes/ReportIdeaChallenges'
import CreateProfiles from '@/components/routes/CreateProfiles'
import EditMyDetails from '@/components/routes/EditMyDetails'
import ReportDashboard from '@/components/routes/ReportDashboard'
import HrbpDashboard from '@/components/routes/HrbpDashboard'
import Reminder from '@/components/routes/Reminder'
import EEReminder from '@/components/routes/EEReminder'
import WorkflowList from '@/components/routes/WorkflowList'
import AuthorNomsList from '@/components/routes/AuthorNomsList'
import ReportArchivedAwards from '@/components/routes/ReportArchivedAwards'
import EMEquity from '@/components/routes/EMEquity'
import EMEquityReview from '@/components/routes/EMEquityReview'
import ReportEEquity from '@/components/routes/ReportEEquity'
import InnovationAwards from '@/components/routes/InnovationAwards'
import InnovationAward from '@/components/routes/InnovationAward'
import ReportInnovationAwards from '@/components/routes/ReportInnovationAwards'

Vue.use(Router)

function restrictPage (next) {
  if (localStorage.getItem('userToken') !== null) {
    next()
  } else {
    next('login')
  }
}

export default new Router({
  routes: [
    {
      path: '/create-profiles',
      name: 'CreateProfiles',
      component: CreateProfiles
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/abuse-report/:id',
      name: 'AbuseReport',
      component: SingleAbuseReport,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/idea/:id',
      name: 'Idea',
      component: SingleIdea,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/supporting-documentation/:id',
      name: 'Supporting documentation',
      component: Media,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/idea-challenges',
      name: 'Idea Challenges',
      component: IdeaChallenges,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/idea-challenges/idea-challenge/:name',
      name: 'Idea Challenge',
      component: IdeaChallenge,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/search/:search',
      name: 'Search',
      component: Search,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/abuse-reports',
      name: 'Abuse reports',
      component: ReportAbuseReports,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/all-ideas',
      name: 'All ideas',
      component: AllIdeas,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/innovation-always-on-site',
      name: 'Innovation Always On Site',
      component: MakeYourMarkChallenge,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/digital-store',
      name: 'Digital store',
      component: DigitalStore,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/all-innovation-always-on',
      name: 'All Innovation Always On',
      component: AllMakeYourMarks,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/employment-equity',
      name: 'Employment Equity',
      component: EMEquity,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/innovation-awards/:name',
      name: 'Innovation Awards',
      component: InnovationAwards,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/innovation-awards',
      name: 'Innovation Awards',
      component: InnovationAward,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/report-innovation-awards',
      name: 'Report: Innovation Awards',
      component: ReportInnovationAwards,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/equity-review/:id',
      name: 'Review Employment Equity Nomination',
      component: EMEquityReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/report-equity',
      name: 'Report Employment Equity',
      component: ReportEEquity,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/recognition',
      name: 'Recognition',
      component: VEAwardMax2Nomination,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/employee-award',
      name: 'Employee Award',
      component: VEAwardsEmployee,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/employee-award-financial',
      name: 'Employee Award',
      component: VEAwardsEmployee,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/employee-award-mar',
      name: 'Employee Award',
      component: VEAwardsEmployee,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },    
    {
      path: '/employee-award-aug',
      name: 'Employee Award',
      component: VEAwardsEmployee,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/bu-employee-award-year',
      name: 'BU Employee of the Year Award',
      component: VEAwardsEmployeeYear,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/employee-award-regional',
      name: 'Employee Award Regional',
      component: VEAwardsEmployeeRegional,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/mcg-employee-award-year',
      name: 'MCG Employee of the Year Award',
      component: VEAwardsMCGEmployeeYear,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/recognition-legacy',
      name: 'Recognition',
      component: VEAward,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/recognition/:name',
      name: 'Recognition',
      component: VEAwards,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    
    {
      path: '/report-ve-awards-old-format',
      name: 'Review: Recognition Awards Old',
      component: ReportVEAwards,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/report-ve-awards',
      name: 'Review: Recognition Awards',
      component: VEAwardForAllRewardReports,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/Reward-Recognition-Report',
      name: 'Reward Recognition Report',
      component: VEAwardForAllRewardReports,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/HCBP-EOM-TOM-Report-HCBP',
      name: 'HCBP EOM/TOM Report',
      component: VEAwardForEmployeeNomination,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/HCBP-EOM-TOM-Report',
      name: 'HCBP EOM/TOM Report',
      component: VEAwardForBUEmployeeNomination,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/HCBP-EOM-TOM-Report-Regional',
      name: 'Regional EOM Report',
      component: VEAwardForEmployeeNominationRegional,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },    
    {
      path: '/BU-EOY-Report',
      name: 'BU EOY Award Report',
      component: VEAwardReportForEmployeeYear,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/MCG-EOY-Report',
      name: 'MCG EOY Award Report',
      component: VEAwardForMCGEmployeeYearReports,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/MCG-EOY-Report-count',
      name: 'MCG EOY Award Report Count',
      component: VEAwardForMCGEmployeeYearCountReports,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },    
    {
      path: '/Recognition-Report/:userType',
      name: 'Recognition Report',
      component: VEAwardForRewardManagerReports,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/report-archived',
      name: 'Review: Archived Awards',
      component: ReportArchivedAwards,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/report-dashboard',
      name: 'Report: Dashboard',
      component: ReportDashboard,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/hrbp/dashboard',
      name: 'HRBP: Dashboard',
      component: HrbpDashboard,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/reminder',
      name: 'Nomination: Reminder',
      component: Reminder,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/eereminder',
      name: 'Employment Equity: Reminder',
      component: EEReminder,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/report-idea-challenges',
      name: 'Report: Idea Challenges',
      component: ReportIdeaChallenges,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/report-make-your-mark',
      name: 'Report: Make your mark',
      component: ReportIdeaChallenges,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/communities',
      name: 'Communities',
      component: Communities,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/communities/community/:name',
      component: Community,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile',
      name: 'My profile',
      component: MyProfile,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/thinktank-user/:name',
      name: 'Profile',
      component: UserProfile,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/review-nomination/:id/:type',
      name: 'Review your nomination',
      component: NominationReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },    
    {
      path: '/my-profile/review-nomination/:id',
      name: 'Review your nomination',
      component: NominationReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/review-manager/:id/:level',
      name: 'Review the nomination',
      component: NominationSponsorReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/review-manager/:id/',
      name: 'Review the nomination',
      component: NominationSponsorReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/downgrade-manager/:id/:level',
      name: 'Downgrade the nomination',
      component: NominationDowngradeReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/downgrade-manager/:id/',
      name: 'Downgrade the nomination',
      component: NominationDowngradeReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/review-nomination-employee-award/:id/:type',
      name: 'Review your nomination',
      component: NominationReviewEmployeeAward,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/review-nomination-employee-award/:id',
      name: 'Review your nomination',
      component: NominationReviewEmployeeAward,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/review-nomination-bu-employee-award/:id',
      name: 'Review your nomination',
      component: NominationBUReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/review-bu-employee-award/:id',
      name: 'Review your nomination',
      component: NominationBUReviewImage,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/my-profile/review-nomination-mcg-employee-award/:id',
      name: 'Review your nomination',
      component: NominationMCGReview,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },    
    {
      path: '/my-profile/review-employee-award/:id/:level',
      name: 'Review the nomination',
      component: NominationManagerEmployeeAward,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },    
    {
      path: '/my-profile/review-employee-award/:id/',
      name: 'Review the nomination',
      component: NominationManagerEmployeeAward,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    /* {
      path: '/my-profile/review-employee-award-test/:id/:level',
      name: 'Review the nomination',
      component: NominationManagerEmployeeAwardTest,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    }, */
    {
      path: '/report-dashboard/:level',
      name: 'Report Dashboard',
      component: WorkflowList,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/report-dashboard/:cat/:author',
      name: 'Report Dashboard',
      component: AuthorNomsList,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/page/:slug',
      name: 'Page',
      component: Page,
      beforeEnter: (to, from, next) => {
        restrictPage(next)
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/my-profile/edit-my-details',
      name: 'Edit My Details',
      component: EditMyDetails
    },
    {
      path: '/login/:return',
      name: 'Login with return',
      component: Login
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})


// WEBPACK FOOTER //
// ./src/router/index.js